import { useContext, useEffect, useState } from 'react'
import LoadingContext from '../../../_metronic/layout/core/Loading'
import { useMainContext } from '../../../context'
import { useAuth } from '../../modules/auth'
import { handleGetRequest } from '../../services'

export interface SupportPlayer {
  _id: string
  first_name?: string
  last_name?: string
  email?: string
}

export const supportPlayerName = (supporter?: SupportPlayer) =>
  `${supporter?.first_name || ''} ${supporter?.last_name || ''}`.trim()

// Supporters of the organisation/unit. Names and e-mails are masked by the backend
// for supporters who have not consented to sharing them with the organisation.
export function useOrgSupportPlayers() {
  const { currentUser } = useAuth()
  const { companyofPortal } = useMainContext()
  const { setLoading } = useContext(LoadingContext)
  const [supporters, setSupporters] = useState<SupportPlayer[]>([])

  const organisationId = currentUser?.user?.organisation_id?._id

  useEffect(() => {
    if (!organisationId) return
    const getSupporters = async () => {
      const sport_id = companyofPortal?.company_id
        ? [companyofPortal?.company_id]
        : currentUser?.user?.sports_list?.map((item: any) => item._id)
      const params = {
        organisation_id: organisationId,
        sport_id,
        only_consented_users: false,
        // Same filter as the supporters page: supporters whose consent has expired are
        // still supporters of the club and must be assignable to a campaign
        only_active: false,
        only_active_expired: true,
        organisation_has_enabled_consent:
          !!currentUser?.user?.organisation_id?.user_consent_sharing_enabled,
        limit: 9999,
        page: 1,
      }
      const res = await handleGetRequest(`/goal_support/support_players`, { params })(setLoading)
      setSupporters(res?.data || [])
    }
    getSupporters()
  }, [organisationId, companyofPortal?.company_id])

  return supporters
}
